/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BisacMainDto model module.
 * @module model/BisacMainDto
 * @version v1.0.0
 */
class BisacMainDto {
    /**
     * Constructs a new <code>BisacMainDto</code>.
     * @alias module:model/BisacMainDto
     */
    constructor() { 
        
        BisacMainDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BisacMainDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BisacMainDto} obj Optional instance to populate.
     * @return {module:model/BisacMainDto} The populated <code>BisacMainDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BisacMainDto();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} code
 */
BisacMainDto.prototype['code'] = undefined;

/**
 * @member {String} id
 */
BisacMainDto.prototype['id'] = undefined;

/**
 * @member {String} name
 */
BisacMainDto.prototype['name'] = undefined;

/**
 * @member {Number} seq
 */
BisacMainDto.prototype['seq'] = undefined;






export default BisacMainDto;

